/**
 * What a completed contractor assignment may still be asked to do, shared by
 * the homeowner's and the designer's Team tab so both sides offer the same
 * actions for the same assignment.
 */

export interface DisputeStatus {
	isExpired: boolean;
	label: string;
}

/**
 * The Dispute action's label and whether its window has closed. Without a
 * completion time there is no window to count from, so the action reads as
 * expired.
 */
export function getDisputeStatus(
	completedAt?: string,
	disputeWindowHours = 72,
): DisputeStatus {
	if (!completedAt) return { isExpired: true, label: "Dispute" };
	const completedTime = new Date(completedAt).getTime();
	const expiryTime = completedTime + disputeWindowHours * 60 * 60 * 1000;
	const remainingMs = expiryTime - Date.now();
	if (remainingMs <= 0) {
		return { isExpired: true, label: "Dispute" };
	}
	const remainingHours = Math.ceil(remainingMs / (1000 * 60 * 60));
	return { isExpired: false, label: `Dispute (${remainingHours}h remaining)` };
}

interface EscrowTransactionLike {
	status: string;
	metadata?: unknown;
}

/** The assignment ids whose escrow hold has already been paid out. */
export function releasedAssignmentIdsFrom(
	transactions: readonly EscrowTransactionLike[] | undefined,
): Set<string> {
	const released = new Set<string>();
	for (const tx of transactions ?? []) {
		const metadata = tx.metadata as Record<string, unknown> | null | undefined;
		if (
			tx.status === "released" &&
			typeof metadata?.assignmentId === "string"
		) {
			released.add(metadata.assignmentId);
		}
	}
	return released;
}
